<template>
  <div class="banner-user">
    <div class="user-base">
      <div class="user-bar" @click="$router.push({ name: 'userInfo' })">
        <div
          class="head-photo"
          :class="`${userInfo.headImage ? 'noBackImg' : ''}`"
        >
          <img
            v-if="userInfo.headImage"
            :src="`${userInfo.headImage}`"
            alt=""
            srcset=""
          />
        </div>
        <div class="user-text">
          <p>Hi~ {{ userInfo.account ? userInfo.account : userInfo.name }}</p>
          <p>欢迎来到小黄牛供应链商城!</p>
        </div>
      </div>
      <div class="userBox" v-if="userInfo.phone">
        <!-- <div class="userInfoCard">
          <div class="moneyBar">
            <span>授信账期余额</span>
            <span>{{ balanceAmount }}</span>
          </div>
          <div class="moneyBar">
            <span>应还</span>
            <span>{{ payBackAmount }}</span>
          </div>
          <div class="goDetail" @click="$router.push('/billPayServer')">
            <span>详情</span>
            <span class="el-icon-arrow-right"></span>
          </div>
        </div> -->
        <!-- <div class="buyPreference">
                  <div class="buyPreference-title">
                      <span>采购偏好</span>
                      <span class="el-icon-edit"></span>
                  </div>
                  <div class="buyPreference-label">
                      <span v-for="(label,index) in userInfo.buyPreference" :key="index">
                          {{label.name}}
                      </span>
                  </div>
              </div> -->
      </div>
      <div class="userBox" v-else>
        <div class="oprationBtn">
          <span
            class="login"
            @click="
              () => {
                this.$router.push({ path: '/login', query: { type: 2 } });
              }
            "
            >登录</span
          >
          <span
            class="register"
            @click="
              () => {
                this.$router.push({ path: '/login', query: { type: 1 } });
              }
            "
            >注册</span
          >
        </div>
        <!-- <div
          class="loginBanner"
          @click="
            () => {
              this.$router.push({ path: '/login', query: { type: 2 } });
            }
          "
        >
          <img src="@/assets/images/login-banner.png" alt="" srcset="" />
        </div> -->
      </div>
      <div v-if="!userInfo.name" style="margin-bottom: 30px"></div>
      <div class="buyInfo">
        <div
          class="buyStatus"
          v-for="item in buyInfo"
          :key="item.name"
          @click="goOrder(item)"
        >
          <div
            class="statusIcon"
            :style="`
                    background:url(${require(`@/assets/images/${item.icon}.png`)}) no-repeat center;
                    background-size:contain;
                  `"
          >
            <span v-if="item.num && userInfo.name">{{ item.num }}</span>
          </div>
          <div>{{ item.name }}</div>
        </div>
      </div>
      <div class="plantform-info" style="background:url(../../../../../static/image/b2c/quanyi_bg.png) no-repeat;background-size:100% 100%;">
        
        <div class="quanyiBox">
          <div class="text1">咖币数字权益</div>
          <div class="text2">致力于打造云南独特的数字权益IP</div>
          <div class="text3">积分余额：<span>0</span></div>
        </div>
        <!-- <div class="plantform-title">
          <span :class="`${active === 1 ? 'active' : ''}`" @click="active = 1"
            >平台公告<span class="hasNewInfo">new</span></span
          >
          <i></i>
          <span :class="`${active === 2 ? 'active' : ''}`" @click="active = 2"
            >最新规则</span
          >
        </div>
        <div class="plantform-box">
          <div
            class="newsList"
            v-if="active === 1"
            :style="`height:${userInfo.name ? 180 : 140}px;`"
          >
            <div
              class="newsBar"
              :class="`${!item.read ? 'noread' : ''}`"
              v-for="item in news"
              :key="item.title"
            >
              <div>{{ item.title }}</div>
            </div>
          </div>
          <div v-else>最新规则...</div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import Cookie from "js-cookie";
import { mapGetters, mapMutations } from "vuex";
import api from "@/api";
import { listSearchMixin } from "@/config/mixin";
import { sendReq } from "../../config/mixin/sendReqMixin";
export default {
  name: "cereBanner",
  mixins: [listSearchMixin],
  props: {},
  data() {
    return {
      payBackAmount: "",
      balanceAmount: "",
      // userInfo:null,
      active: 1,
      news: [
        {
          title: "校园供应链建设项目启动，全面开启数字隆阳新时代！",
        },
        {
          title: "辞旧鞭炮催春潮，迎新锣鼓闹元宵。",
        },
        {
          title: "万象更新，2022一起向未来。",
        },
        {
          title: "弘扬民俗文化·共迎新春佳节，数产举办2022年迎新春活动",
          read: true,
        },
        {
          title:
            "【凝心聚力 砥砺前行】数产21年工作总结大会召开",
          read: true,
        },
      ],
      buyInfo: [
        {
          name: "待付款",
          num: 0,
          icon: "user_info_icon01",
          activeName: "second",
          state: "1",
        },
        {
          name: "待发货",
          num: 0,
          icon: "user_info_icon02",
          activeName: "third",
          state: "2",
        },
        {
          name: "待收货",
          num: 0,
          icon: "user_info_icon03",
          activeName: "fourth",
          state: "3",
        },
        {
          name: "已完成",
          num: 0,
          icon: "finish2",
          activeName: "ten",
          state: "",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["userInfo", "shoppingCart", "cartNumber", "city_location"]),
  },
  mounted() {
    // console.log(Cookie.get('token'))
    // let token = Encrypt(Cookie.get('token'))
    // let username = encodeURI(this.userInfo.name)
    // let userInfo = encodeURI(username)
    // 获取该用户的订单数据
    if (Cookie.get("token")) {
      this.creditList();
      this.getOrderList(1);
      this.getOrderList(2);
      this.getOrderList(3);
    }
  },
  methods: {
    creditList() {
      let params = {
        url: api.creditList,
        method: "post",
        data: {
          page: 1,
          pageSize: 9999,
          shopName: "",
        },
      };
      this.sendReq(params, (res) => {
        if (res.code == 200) {
          let payBackAmount = res.data.list.reduce(
            (init, obj) => init + obj.payBackAmount,
            0
          );
          let balanceAmount = res.data.list.reduce(
            (init, obj) => init + obj.balanceAmount,
            0
          );
          this.payBackAmount = payBackAmount.toFixed(2);
          this.balanceAmount = balanceAmount.toFixed(2);
        }
      });
    },
    goOrder({ activeName, state }) {
      this.$router.push({
        path: "/myOrder",
        query: {
          activeName,
          state,
        },
      });
    },
    // 获取订单数量
    getOrderList(state = 1) {
      let self = this;
      let params = {
        url: api.getOrderList + `?state=${state}&page=1&pageSize=999`,
        method: "GET",
        data: {},
      };
      self.sendReq(params, (res) => {
        if (res.code === "200") {
          self.buyInfo[state - 1].num = res.data.total;
        } else {
          self.$message({
            message: res.message,
            type: "warning",
          });
        }
      });
    },
    // goLogin(){
    //     this.userInfo = {
    //         name:'保山市第一中学',
    //         creditPeriodBalance:'10000.00',
    //         debt:'2000.00',
    //         buyPreference:[
    //             {name:'厨房调料'},
    //             {name:'生猪禽肉'},
    //             {name:'瓜果蔬菜'},
    //             {name:'学习文具'},
    //         ]
    //     }
    // }
  },
};
</script>
<style lang="scss" scoped>
.banner-user {
  position: absolute;
  right: 0;
  top: 10px;
  width: 310px;
  height: 610px;

  // background: linear-gradient(180deg, #ffc99a 0%, #fbe5d6 50%, #fff 100%);
  background: #fff;
  border-radius: 8px;
  //box-shadow: 2px 2px 10px #cccccc59;
  .store-box {
    .a-link {
      display: block;
      height: 492px;
      width: 100%;
    }
  }
  .user-base {
    padding: 50px 23px 38px;
    .user-bar {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      //height: 60px;
      margin-bottom: 36px;
      width:100%;
      cursor: pointer;
      .head-photo {
        height: 60px;
        width: 60px;
        border-radius: 50%;
        background: url(../../../../assets/images/defaultHeadImg.png) no-repeat
          center;
        background-size: cover;
        overflow: hidden;
        margin-right: 9px;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          height: 100%;
        }
      }
      .noBackImg {
        background: #ffffff;
      }
      .user-text {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        p {
          font-size: 14px;
          color: #000;
        }
      }
    }
  }
  .oprationBtn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    span {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 116px;
      height: 46px;
      background: #f77b0b;
      border-radius: 26px;
      color: #ffffff;
      font-size: 16px;
      cursor: pointer;
    }
    .register {
      //border: 1px solid #f77b0b;
      color: #ffff;
      background: #2D8BFF;
    }
    span:hover {
      opacity: 0.9;
    }
  }
  .loginBanner {
    height: 92px;
    margin-top: 27px;
    margin-bottom: 38px;
    cursor: pointer;
    img {
      width: 100%;
      overflow: hidden;
    }
    // background: #fc8c2a;
  }
  .userInfoCard {
    height: 104px;
    overflow: hidden;
    background: url(../../../../assets/images/user-info-credit.png) no-repeat
      center;
    background-size: cover;
    border-radius: 5px;
    padding: 14px 19px;
    margin-bottom: 27px;
    // margin-top: 17px;
    .moneyBar {
      color: #ffffff;
      // display: flex;
      // align-items: center;
      margin-bottom: 6px;
      span {
        font-size: 14px;
      }
      span:first-child {
        font-size: 12px;
        opacity: 0.7;
        margin-right: 7px;
      }
    }
    .goDetail {
      display: flex;
      width: 57px;
      height: 22px;
      border-radius: 22px;
      background: #bfcefe;
      font-size: 12px;
      color: #1449ce;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      .el-icon-arrow-right {
        margin-left: 5px;
      }
      .el-icon-arrow-right:before {
        color: #1449ce;
      }
    }
    .goDetail:hover {
      opacity: 0.9;
    }
  }
  .buyPreference {
    .buyPreference-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 16px;
      .el-icon-edit:before {
        color: #f77b0b;
        cursor: pointer;
      }
    }
    .buyPreference-label {
      display: flex;
      // justify-content: space-between;
      flex-wrap: wrap;
      span {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 56px;
        height: 30px;
        background: rgba(247, 123, 11, 0.15);
        border-radius: 2px;
        margin-top: 12px;
        color: #f77b0b;
        font-size: 12px;
        cursor: pointer;
        margin-right: 12.5px;
      }
      span:hover {
        opacity: 0.9;
      }
      span:nth-child(4n) {
        margin-right: 0px;
      }
    }
  }
  .buyInfo {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 31px;
    .buyStatus {
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
      .statusIcon {
        width: 30px;
        height: 27px;
        position: relative;
        margin-bottom: 12px;
        span {
          display: flex;
          justify-content: center;
          align-items: center;
          position: absolute;
          border-radius: 50%;
          right: -11px;
          top: -11px;
          width: 22px;
          height: 22px;
          background: #ff4747;
          border: 1px solid #ffffff;
          color: #ffffff;
          font-size: 12px;
        }
      }
    }
  }
  .plantform-info {
    padding: 60px 40px;
    height: 230px;
    .quanyiBox{
      .text1{
        font-size: 16px;
        font-weight: bold;
        color: #fff;
        margin-bottom: 10px;
      }
      .text2{
        font-size: 12px;
        color: #fff;
        margin-bottom: 10px;
      }
      .text3{
        font-size: 14px;
        color: #fff;
        margin-top: 50px;
        span{
          font-size: 18px;
          font-weight: bold;
        }
      }
    }
    margin-top: 31px;
    .plantform-title {
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: bold;
        cursor: pointer;
      }
      span.active {
        color: #f77b0b;
      }
      i {
        display: inline-block;
        width: 2px;
        height: 24px;
        border: 1px solid #e5e5e5;
        margin: 0 28px;
      }
      .active {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .hasNewInfo {
        margin-left: 7px;
        width: 32px;
        height: 15px;
        background: #ff4747;
        font-size: 12px;
        font-weight: bold;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        padding-bottom: 2px;
      }
      .hasNewInfo:before {
        content: "";
        border: 4px solid transparent;
        border-right-color: #ff4747;
        position: absolute;
        left: -8px;
        top: 50%;
        margin-top: -4px;
      }
    }
    .plantform-box {
      // position: absolute;
      padding: 20px 0 0 0;
      .newsList {
        font-size: 14px;
        color: #606266;

        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .newsBar {
          display: flex;
          align-items: center;
          // margin-top: 17px;
          cursor: pointer;
          div {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 90%;
            font-size: 14px;
            color: #606266;
          }
        }
        .newsBar.noread:before {
          content: "";
          display: inline-block;
          height: 5px;
          width: 5px;
          border-radius: 50%;
          background-color: #f77b0b;
          margin-right: 7px;
          // flex: 1;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/canvasShow/cereshop/pc_b2c/bannerUserInfo.vue